module.exports = __webpack_public_path__ + "img/banner-list-4.0a73ad0c.svg";